export default "__VITE_ASSET__DeQjxL59__"